import { useEffect, useState } from 'react';
import { getBillingPolicy, getBillingPolicyByOps } from 'api/paymentSetup';
import { BillingPolicyType, IBillingPolicy } from 'types/paymentSetup';

const initData: IBillingPolicy[] = [
    {
        type: BillingPolicyType.NO_SHOW,
        timeFrame: 15,
        fee: 25.00,
        enable: true,
    },
    {
        type: BillingPolicyType.LATE_CANCELLATION,
        timeFrame: 24,
        fee: 25.00,
        enable: true,
    },
];

export const useBillingPolicy = (isOps?: boolean, providerId?: number): [IBillingPolicy[], boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<IBillingPolicy[]>(initData);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = isOps ? await getBillingPolicyByOps(providerId!) : await getBillingPolicy();
            if (!result.error) {
                const data: IBillingPolicy[] = result?.data?.data || initData;
                setServiceData(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [serviceData, loading, fetchData];
};
